import { MenuItemType, OrganizedMenu } from "../../types/restaurant.types";
import { MenuFilterState } from "./FilterTypes";

export const filterAndSortMenuItems = (
  menuItems: MenuItemType[],
  filters: MenuFilterState
): MenuItemType[] => {
  let filteredItems = [...menuItems];

  // Apply food type filter
  if (filters.foodType.length > 0) {
    filteredItems = filteredItems.filter((item) =>
      filters.foodType.includes(item.foodType)
    );
  }

  // Apply rating filter
  if (filters.rating) {
    filteredItems = filteredItems.filter(
      (item) => item.avgReview >= filters.rating!
    );
  }

  // Apply sorting
  switch (filters.sortBy) {
    case "price-low-high":
      filteredItems.sort((a, b) => a.price - b.price);
      break;
    case "price-high-low":
      filteredItems.sort((a, b) => b.price - a.price);
      break;
    case "rating-high-low":
      filteredItems.sort((a, b) => b.avgReview - a.avgReview);
      break;
  }

  return filteredItems;
};

export const organizeFilteredMenu = (
  filteredItems: MenuItemType[]
): OrganizedMenu => {
  const organized: OrganizedMenu = {};

  filteredItems.forEach((item) => {
    if (!organized[item.category]) {
      organized[item.category] = {
        name: item.category,
        subCategories: {},
      };
    }

    if (!organized[item.category].subCategories[item.subCategory]) {
      organized[item.category].subCategories[item.subCategory] = {
        name: item.subCategory,
        items: [],
        isEnabled: true,
      };
    }

    organized[item.category].subCategories[item.subCategory].items.push(item);
  });

  return organized;
};
